import { LevelRequirementStatus } from '@/client/services/worlds/progression/enum'

import type { GrowthPathLevelStepDetails } from './types'

export function findCurrentStepIndex(steps: GrowthPathLevelStepDetails[]): number | null {
  const firstStepIndex = steps.findIndex(
    step =>
      step.requirement.isOptional !== true &&
      (step.status === LevelRequirementStatus.Incomplete ||
        step.status === LevelRequirementStatus.Locked ||
        (step.status === LevelRequirementStatus.InProgress &&
          step.requirement.type === 'requirement-group' &&
          !step.requirement.doNotBlockWhenInProgress))
  )

  if (firstStepIndex === -1) {
    const firstInProgressStep = steps.findIndex(
      step => step.status === LevelRequirementStatus.InProgress
    )
    return firstInProgressStep === -1 ? null : firstInProgressStep
  }

  if (steps[firstStepIndex].status === LevelRequirementStatus.Locked) {
    return null
  }

  return firstStepIndex
}
